import React from 'react'
import LOOKUP from 'constants/lookup';
import { getDollarFormat } from 'utils/helpers';
import { mapPriceMatrix, mapSKUMapping } from 'utils/mappers';
import CardSimple from 'screens/components/basic/CardSimple';
import GenericTable from 'screens/components/advanced/GenericTable';
import InventoryLevel from './InventoryLevel';


const Information = ({ product, printLabel, isMedical, inventory, inventoryFilter }) => {
    let priceMatrix = product.priceMatrix ? product.priceMatrix.priceMatrixDetails : [];
    return (
        <div className="product-content" style={{ padding: "1% 0% 0%" }}>
            <h4> General Information </h4>
            <div className="flex-div">
                <div className="bg-blue-p bg-ClassicBlue">
                    <p className="flex-label">SKU</p>
                    <p className="flex-data">{product.sku}</p>
                </div>
                <div className="bg-green-p bg-ClassicGreen">
                    <p className="flex-label">Category</p>
                    <p className="flex-data">{product.category}</p>
                </div>
                <div className="primary-color-bg bg-ClassicPurple">
                    <p className="flex-label">Type</p>
                    <p className="flex-data">{product.type}</p>
                </div>
                <div className="bg-gray-Purple-p bg-ClassicGray">
                    <p className="flex-label">Latest Base Cost / (Margin)</p>
                    {product.unitPrice ? 
                    <p className="flex-data">{getDollarFormat(product.latestBaseCost)} / ({(((product.unitPrice - product.latestBaseCost) / product.unitPrice) * 100).toFixed(2)}%)</p>
                    :
                    <p>N.A</p>
                    }
                </div>
                <div className="bg-gray-Purple-p bg-ClassicGray">
                    <p className="flex-label">Average Base Cost / (Margin)</p>
                    {product.unitPrice ?
                    <p className="flex-data">{getDollarFormat(product.baseCost)} / ({(((product.unitPrice - product.baseCost) / product.unitPrice) * 100).toFixed(2)}%)</p>
                    :
                    <p>N.A</p>
                    }
                    
                </div>
                <div className="bg-dark-p bg-ClassicDark">
                    <p className="flex-label">Status</p>
                    <p className="flex-data">{product.status}</p>
                </div>
                {
                    product.type === "Unit" && product.weightPerUnit !== null ?
                        <div className="bg-dark-blue">
                            <p className="flex-label">Weight per Unit</p>
                            <p className="flex-data">{product.weightPerUnit}g</p>
                        </div>
                        :
                        ""
                }
            </div>

            <h4> SKU Mapping Information </h4>
            <div className="product-content list-table">
                <CardSimple>
                    <GenericTable
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={false}
                        stripedRows={true}
                        columns={LOOKUP.product.tableSKUMapping}
                        rows={mapSKUMapping(product.productSupplier)}
                    />
                </CardSimple>
            </div>
            {(product.priceMatrixId !== 0) &&
                <div>
                    <h4> Price Information </h4>
                    <div className="product-content prices">
                        <CardSimple>
                            <GenericTable
                                className="table_center text-left tableHeaderwhiteColorFont"
                                tableBodyClassName="price-matrix-weight-table"
                                multiSelectable={false}
                                enableSelectAll={false}
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                displayRowCheckbox={false}
                                selectable={false}
                                stripedRows={true}
                                columns={isMedical ? LOOKUP.priceMatrix.patientView.tableColumns : LOOKUP.priceMatrix.patientView.tableColumnsRetail}
                                rows={mapPriceMatrix(priceMatrix, printLabel, product.id)} />
                        </CardSimple>
                    </div>
                </div>
            }
            <br />
            <div>
                <h4> Inventory Information </h4>
                <InventoryLevel inventory={inventory} inventoryFilter={inventoryFilter} />
            </div>
        </div>
    )
}

export default Information;
